
<template>
  <div>
    <!-- <el-tabs value="0" type="card">
      <el-tab-pane
        v-for="(item,index) in list"
        :key="index"
        :label="item.typeNam
        :name="index+''"
        style="margin-bottom: 31px;"
      > -->
    <div v-for="(it, index) in list" :key="index" style="height: 3%">
      <!-- <div style="display: inline-block;width: 2%;float:left;margin-top: 9px;width: 20px">
            <span :class="it.icon ? it.icon:'iconfont icon-read1'" style="width: 2px"></span>
          </div> -->
      <div style="width: 100%" class="news">
        <div class="news_item">
          <p class="news_item__left">
            <!-- <i
              :class="it.icon ? it.icon : 'iconfont icon-read1'"
              style="width: 20px;margin-top: 7px;"
            ></i> -->
            
            <el-link
              :underline="false"
              @click="openParticulars(it.id)"
              style="font-size:14px;font-family:Microsoft YaHei;font-weight:normal;color:#171616;line-height:30px;">
              
                <div style="display: flex;">
                  <span v-if="it.status=='未读'" style="margin: 0px 8px 0px 0px;padding-top: 3px;">
                    <img src="/fvue/img/msg_own.png" >
                  </span>
                  <span v-else style="margin: 0px 8px 0px 0px;padding-top: 3px;">
                    <img src="/fvue/img/msg_none.png" >
                  </span>
                  <span class="news_item__link">{{ it.title }}</span>
                </div>
                <p class="news_item__right" v-if="!it.titleDescription">
                  {{ it.drafter }} | {{ it.createTime }}
                </p>
            </el-link>
          </p>
        </div>
        <div v-if="it.titleDescription">
          <span
            style="font-size:12px;font-family:Microsoft YaHei;font-weight:400;color:#797979;line-height:30px;"
            >{{ it.titleDescription }}</span
          >
          <span
            style="float:right;font-family:Microsoft YaHei;font-weight:400;color:rgba(169,173,183,1);line-height:30px;"
            >{{ it.drafter }} | {{ it.createTime }}</span
          >
        </div>

        <!-- <div
          style="margin-top:2px;height:1px;background:rgba(235,238,245,1);"
        ></div> -->
      </div>
    </div>

    <!-- </el-tab-pane>
    </el-tabs> -->
    <homeNewsParticulars ref="homeNewsParticulars" :id="selectId" />
  </div>
</template>
<script>
import req from "@/request.js";
import homeNewsParticulars from "@/components/home/homeNewsParticulars.vue";
export default {
  props: {
    classifyId: {
      default: "all",
    },
  },
  data() {
    return {
      list: [],
      selectId: null,
      User:JSON.parse(window.sessionStorage.currentUser)
    };
  },
  components: { homeNewsParticulars },
  created() {
    this.init();
  },

  methods: {
    openParticulars(id) {
      let param = {
        xm:this.User.username,
        gh:this.User.account,
        ggbt:"",
        ggbm:id,
      };
      window.app.$http.post(window.context.bpmRunTime + "/message/SaveNewsItem", param).then(resp => {//插入查阅记录表
      });
      this.selectId = id;
      this.$refs.homeNewsParticulars.openDialog();

    },
    init() {
      req
        .get(
          window.context.portal +
            "/portalNewsNotice/v1/getNews?classifyId=" +
            this.classifyId
        )
        .then((response) => {
          if(response.data!=null){
            for(let i=0;i<response.data.length;i++){
              if(response.data[i].start_=='启用'){
                this.list.push(response.data[i]);
              }
            }
          }

        });
    },
  },
};
</script>
<style lang="scss" scoped>

.news{
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 0px;
  padding-right: 0px;
  &:hover{
    background:#EDF6FB;
    .news_item__link{
      color: #1890FF !important;
    }
    .news_item__right{
      color: #1890FF !important;
    }
  }
}
.news_item {
  width: 100%;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #171616;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
  .news_item__left {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin: 0;
  }
  .news_item__right {
    margin: 0px;
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9D9FAD;
    line-height: 22px;
  }
  .news_item__link{//新ui
    padding-bottom: 0px;
    height: 30px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #292B44;
    line-height: 30px;
    /*文字超出省略*/
    display: -webkit-box;
    display: -moz-box;
    white-space: pre-wrap;
    word-break:break-all;
    word-wrap:break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:1;   /*显示行数*/
  }
  /deep/ .el-link--inner{/*处理缩略后的换行符*/

    height: 48px;
    margin-left: 24px;

    br{
      display: none;
    }
  }
}
</style>
